const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

export default class LeavingSiteModal {


  // Constructor
  constructor(element, links) {
    this.element = element;

    this.leavingSiteClickHandler = this.leavingSiteClickHandler.bind(this)
    this.closeClickHandler = this.closeClickHandler.bind(this)
    this.popupClickHandler = this.popupClickHandler.bind(this)
    this.popupOverlayCloseHandler = this.popupOverlayCloseHandler.bind(this)

    links.forEach((link) => {
      link.addEventListener('click', this.leavingSiteClickHandler)
    })

    this.element.querySelector('#leaving-site-modal-cancel').addEventListener('click', this.closeClickHandler);
    this.element.addEventListener('mousedown', this.popupOverlayCloseHandler)
  }

  leavingSiteClickHandler(e) {
    this.element.querySelector('#leaving-site-modal-link').setAttribute('href', e.currentTarget.dataset.href)
    this.element.classList.add('show')
    disableBodyScroll(this.element)
  }

  close() {
    this.element.classList.remove('show')
    enableBodyScroll(this.element)
  }

  closeClickHandler(e) {
    this.close()
  }

  popupClickHandler(e) {
    e.stopPropagation();
  }

  popupOverlayCloseHandler(e) {
    
    if (e.target.closest('.leaving-site-modal--popup')) {
      return;
    }

    this.close()
  }

  // Public Methods
  resize() {
  }
}
